import React, { useState, useEffect } from 'react';
import './ShinyCursor.css';

const ShinyCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isClicking, setIsClicking] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    // Check if device has mouse support (desktop/laptop)
    const hasMouseSupport = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    setIsDesktop(hasMouseSupport);

    // Only add mouse event listeners on desktop
    if (!hasMouseSupport) return;

    const updateMousePosition = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    const handleMouseDown = () => setIsClicking(true);
    const handleMouseUp = () => setIsClicking(false);

    document.addEventListener('mousemove', updateMousePosition);
    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
      document.removeEventListener('mousemove', updateMousePosition);
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);

  // Don't render cursor on mobile/touch devices
  if (!isDesktop) {
    return null;
  }

  return (
    <div
      className={`xp-cursor ${isClicking ? 'clicking' : ''}`}
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
      }}
    />
  );
};

export default ShinyCursor;
